import { Browser } from '@src/infrastructure/browser';
import { ErrorHandler } from '@src/infrastructure/errorHandler';
import { HttpClient } from '@src/infrastructure/httpClient/index';
import { routes } from '@src/infrastructure/routes';
import { ServerSettings } from '@src/infrastructure/serverSettings';
import { CartStore } from '@src/infrastructure/storage/cartStore';

type CartItems = 'blaze' | 'luminex' | 'no-steno';

export class PricingAndOrdering {
    private readonly httpClient: HttpClient;
    private readonly cartStore: CartStore;
    private readonly errorHandler: ErrorHandler;
    private readonly browser: Browser;

    constructor(serverSettings: ServerSettings){
        this.httpClient = new HttpClient(serverSettings);
        this.cartStore = new CartStore();
        this.browser = new Browser();
        this.httpClient = new HttpClient(serverSettings);
    }

    addBlazeToCart = async () => {
        await this.addToCart('blaze');
    }

    addLuminexToCart = async () => {
        await this.addToCart('luminex');
    }

    addNoStenoToCart = async () => {
        await this.addToCart('no-steno');
    }

    private async addToCart(cartItem: CartItems) {
        try {
            const cart = await this.cartStore.get();
            const item = cart.cartItems.find(c => c.item === cartItem);
            if (!item) {
                cart.cartItems.push({ item: cartItem, amount: 1 });
            }
            else {
                item.amount++;
            }
            await this.cartStore.set(cart);
            this.browser.gotoUrl(routes.web.cart);
        }
        catch (e) {
            this.errorHandler.handleError(e);
        }
    }
}   